import i18n from 'i18next';
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

import spanish from '../locales/es/translation.json';
import english from '../locales/en/translation.json';
import portuguese from '../locales/pt/translation.json';

export type SupportedLanguage = 'en' | 'es' | 'pt';
export const supportedLanguages: SupportedLanguage[] = ['en', 'es', 'pt'];

const resources = {
  es: { translation: spanish },
  en: { translation: english },
  pt: { translation: portuguese }
};

i18n
.use(LanguageDetector)
.use(initReactI18next)
.init({
  resources,
  fallbackLng: 'en',
  debug: import.meta.env.DEV,
  supportedLngs: supportedLanguages,
  load: "languageOnly",
  interpolation: {
    escapeValue: false
  },
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
    lookupLocalStorage: 'i18nextLng',
    lookupFromPathIndex: 0,
    excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
  }
});

export default i18n;